module.exports = __webpack_public_path__ + "img/be232eb.png";